'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { useVeritonic } from '@nwwp/veritonic'

export const VeritonicPageTracker = () => {
  const { trackView, isReady } = useVeritonic()
  const pathname = usePathname()
  const lastTrackedPath = useRef<string | null>(null)

  useEffect(() => {
    // Track a view once per pathname. Keying the ref on `pathname` (rather than
    // a plain fire-once boolean) de-dupes repeat fires for the same page when
    // `trackView`'s identity changes, while still re-tracking on navigation.
    if (isReady && lastTrackedPath.current !== pathname) {
      lastTrackedPath.current = pathname
      trackView()
    }
  }, [pathname, isReady, trackView])

  return null
}
